import { render, staticRenderFns } from "./OverviewKeyTraits.vue?vue&type=template&id=611fdec6"
import script from "./OverviewKeyTraits.vue?vue&type=script&lang=js"
export * from "./OverviewKeyTraits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports